const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export default (object, name, locale) => ['partial', 'full'].includes(object[`${name}${capitalizeFirstLetter(locale)}`]?.matchLevel) 
    ? object[`${name}${capitalizeFirstLetter(locale)}`] 
    : ['partial', 'full'].includes(object[name]?.matchLevel)
        ? object[name] 
        : null;